export const MEMBER_ERROR_MESSAGES = {
  INVALID_PASSCODE: "兑换码不正确，请检查后重新输入",
  ACCOUNT_FROZEN: "账号已暂停使用，请联系客服处理",
  MEMBER_EXPIRED: "会员已到期，请联系客服续费",
  CODE_REVOKED: "这个兑换码已经失效，如有疑问请联系客服",
  DAILY_LIMIT_REACHED: "今天的领取次数已用完，明天可以继续领取",
  CYCLE_LIMIT_REACHED: "本周期次数已用完，可在「我的权益」查看恢复时间",
  ALREADY_REDEEMED: "这个主题已经领取过，可在领取记录中查看资源",
  RESOURCE_NOT_CONFIGURED: "这个主题的资源暂未上架，请联系客服获取",
  SERVICE_ERROR: "网络或服务异常，请稍后重试",
} as const;

export type MemberErrorCode = keyof typeof MEMBER_ERROR_MESSAGES;

export function getMemberErrorMessage(
  code: string | null | undefined,
  fallback = MEMBER_ERROR_MESSAGES.SERVICE_ERROR,
): string {
  if (code && code in MEMBER_ERROR_MESSAGES) {
    return MEMBER_ERROR_MESSAGES[code as MemberErrorCode];
  }
  return fallback;
}
